<template>
  <div class="homepageWrap" ref="homeModal">
    <div class="headWrap">
      <HeadBanner @toDesignMobile="toDesignMobile" @toDesign="goDesign"></HeadBanner>
    </div>
    <div class="pc_why_choose">
      <div class="mainWrap">
        <div class="chooseWrap">
          <div class="tabLt">
            <div
              class="tabItem"
              :class="{ on: howIndex === index }"
              @click="cdstClick(index)"
              v-for="(item, index) in howItWorksList"
              :key="index"
            >
              <span class="iconSp">
                <img loading="lazy" class="curIcon" :src="item.icon">
                <img loading="lazy" class="hoverIcon" :src="item.iconHover">
              </span>
              <span>{{ item.content }}</span>
            </div>
          </div>
          <div class="infoRt">
            <div class="scrollWrap" :style="{ transform: `translateX(-${howIndex * 750}px)` }">
              <div class="infoItem" v-for="(item, index) in howItWorksList" :key="index">
                <img loading="lazy" :src="item.imgSrc" :alt="item.alt">
                <div class="tipWrap">{{ item.descr }}</div>
              </div>
            </div>
            <div class="scrollTba">
              <span
                :class="{ on: howIndex === index }"
                @click="cdstClick(index)"
                v-for="(item, index) in howItWorksList"
                :key="index"
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mb_why_choose">
      <div class="mainWrap">
        <div class="mbChooseWrap">
          <div class="mbChooseItem" v-for="(item, index) in howItWorksList" :key="index">
            <div class="imgBox">
              <img loading="lazy" :src="item.mbImgSrc" :alt="item.alt">
            </div>
            <div class="infoBox">
              <h5>{{ item.content }}</h5>
              <p>{{ item.descr }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="productBlock">
      <div class="mainWrap">
        <div class="product_wrap">
          <h3 class="comTitle">
            Unleash Your Inner Designer and
            <br>Turn Your Ideas into Profit with PrintDoors
          </h3>
          <div class="product_list">
            <div
              class="product"
              v-for="(item, index) in productList"
              :key="index"
              @click="$router.push('/products/category/' + item.category)"
            >
              <div class="img-wrap">
                <img loading="lazy" class="img" :src="item.showSrc" :alt="item.alt">
                <!-- <img class="hoverImg" :src="item.hoverImgSrc" /> -->
              </div>
              <span class="name">{{ item.title }}</span>
            </div>
          </div>
        </div>
        <div class="moreWrap">
          <a @click="$router.push('/products')">Show more></a>
        </div>
      </div>
    </div>

    <div class="integration_options">
      <div class="mainWrap">
        <h3 class="comTitle">
          Integrate PrintDoors
          <br>with Your Preferred Platform or Marketplace
        </h3>
        <div class="store_list">
          <a
            v-for="(item, index) in storeList"
            :key="index"
            class="store"
            :href="item.url"
            target="_blank"
          >
            <a-tooltip v-if="index === 1" class="tip_icon">
              <template slot="title">
                The term 'Etsy' is a trademark of Etsy, Inc. This application uses the Etsy API but is not endorsed or
                certified by Etsy, Inc.
              </template>
              <a-icon type="question-circle" theme="filled"/>
            </a-tooltip>
            <img loading="lazy" :src="item.imgSrc" :alt="item.alt">
          </a>
        </div>
      </div>
    </div>
    <div class="choose_printdoors">
      <div class="mainWrap">
        <h3 class="comTitle">
          Why to Choose
          <span>PrintDoors</span>?
        </h3>
        <div class="comTitTip">
          At PrintDoors, we hold the belief that every individual should be able to avail themselves of a diverse
          assortment of printing options that are both reasonably priced and of superior quality.
        </div>
        <div class="choose_printdoors_list">
          <div
            class="choose_printdoors_item"
            v-for="(item, index) in choosePrintdoorsList"
            :key="index"
          >
            <div class="imgBox">
              <img loading="lazy" :src="item.imgSrc" :alt="item.alt">
            </div>
            <div class="chooseTit" :class="{ mt: index === 5 }">{{ item.content }}</div>
            <div class="chooseTip" :class="{ mt: index === 5 }">{{ item.descr }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- v-if="!getToken" -->
    <div class="signUp">
      <div class="mainWrap" @click="toLogin()">
        <img loading="lazy" class="pc_sign" src="@/assets/homePage/pc_sign.png">
        <img loading="lazy" class="mb_sign" src="@/assets/homePage/mb_sign.png">
      </div>
    </div>
    <!-- 人物介绍start -->
    <div class="customers_option pc_customers_option">
      <div class="mainWrap">
        <h3 class="comTitle">Our customers opinion</h3>
      </div>
      <div class="customer_option_list">
        <swiper ref="myPcSwiper" :options="swiperOption">
          <swiper-slide v-for="(item, index) in customerOptionList" :key="index">
            <div class="swiperWrap">
              <div
                class="customers_option_item"
                :style="{ backgroundImage: `url(${item.avatar})` }"
              >
                <div class="avatar_wrap">
                  <div class="name">
                    {{ item.name }}
                    <span>{{ item.tip }}</span>
                  </div>
                  <div class="star_wrap">
                    <div v-for="index of 5" :key="index">
                      <img
                        loading="lazy"
                        src="@/assets/homePage/star1.png"
                        v-if="index <= item.score"
                      >
                      <img loading="lazy" src="@/assets/homePage/star2.png" v-else>
                    </div>
                  </div>
                </div>
                <div class="customer_option_content">{{ item.content }}</div>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <div class="customers_option mb_customers_option">
      <div class="mainWrap">
        <h3 class="comTitle">Our customers opinion</h3>
        <div class="customer_option_list">
          <swiper ref="myMbSwiper" :options="swiperOption1">
            <swiper-slide v-for="(item, index) in customerOptionList" :key="index">
              <div class="swiperWrap">
                <div
                  class="customers_option_item"
                  :style="{ backgroundImage: `url(${item.avatar})` }"
                >
                  <div class="avatar_wrap">
                    <div class="name">
                      {{ item.name }}
                      <span>{{ item.tip }}</span>
                    </div>
                    <div class="star_wrap">
                      <div v-for="index of 5" :key="index">
                        <img
                          loading="lazy"
                          src="@/assets/homePage/star1.png"
                          v-if="index <= item.score"
                        >
                        <img loading="lazy" src="@/assets/homePage/star2.png" v-else>
                      </div>
                    </div>
                  </div>
                  <div class="customer_option_content">{{ item.content }}</div>
                </div>
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
    </div>
    <!-- 人物介绍end -->
    <div class="hot_sale">
      <div class="mainWrap">
        <h3 class="comTitle">Hot Sale Products</h3>
        <HotSale></HotSale>
      </div>
    </div>
    <div class="blog_block">
      <div class="mainWrap">
        <h3 class="comTitle">Blog</h3>
        <div class="blogWrap">
          <div
            class="blogItem"
            @click="
              toBlog('https://www.printdoors.com/blog/print-on-demand-style-8-money-making-t-shirt-trends-for-2023/')
            "
          >
            <div class="imgBox">
              <img
                loading="lazy"
                class="hoverImg"
                src="@/assets/homePage/blog_1.png"
                alt="print on demand designs"
              >
            </div>
            <div class="blogTitle">Print-On-Demand Style: 8 Money Making T-Shirt Trends for 2023</div>
            <div class="blogTip">
              As a print-on-demand seller, there is a very small window for being one of the first ones to an emerging
              trend in order to maximize the amount of profit you are going to make while everybody else is focused on
              all the festivities and the holidays right now. Differently, you should concentrate on what trends you can
              jump on to have an amazing 2023 and make more sales and more profit. Printdoors has been doing a lot of
              research for POD sellers or models so we have come up with some good ideas, which you can actually take in
              to run in the New Year.
            </div>
            <div class="hoverWrap" @click.stop>
              <h1>Print-On-Demand Style: 8 Money Making T-Shirt Trends for 2023</h1>
              <div class="hoverTip">
                As a print-on-demand seller, there is a very small window for being one of the first ones to an emerging
                trend in order to maximize the amount of profit you are going to make while everybody else is focused on
                all the festivities and the holidays right now. Differently, you should concentrate on what trends you
                can jump on to have an amazing 2023 and make more sales and more profit. Printdoors has been doing a lot
                of research for POD sellers or models so we have come up with some good ideas, which you can actually
                take in to run in the New Year.
              </div>
              <div
                class="btnBt"
                @click="
                  toBlog(
                    'https://www.printdoors.com/blog/print-on-demand-style-8-money-making-t-shirt-trends-for-2023/'
                  )
                "
              >Read more></div>
            </div>
          </div>
          <div
            class="blogItem"
            @click="toBlog('https://www.printdoors.com/blog/print-on-demand-trends-how-to-be-creative-and-profitable/')"
          >
            <div class="imgBox">
              <img
                loading="lazy"
                class="hoverImg"
                src="@/assets/homePage/blog_2.png"
                alt="print on demand products"
              >
            </div>
            <div class="blogTitle">Print on Demand Trends: How to be Creative and Profitable</div>
            <div class="blogTip">
              Print on demand is a service that enables customers to create, customize and purchase products from an
              online print shop. Designers, shop owners, or online sellers transform ideas and designs into products
              through suppliers and then publish them on their own websites and online stores for sale. The products
              will be directly produced, printed, and shipped to their customers by the suppliers .
            </div>
            <div class="hoverWrap" @click.stop>
              <h1>Print on Demand Trends: How to be Creative and Profitable</h1>
              <div class="hoverTip">
                Print on demand is a service that enables customers to create, customize and purchase products from an
                online print shop. Designers, shop owners, or online sellers transform ideas and designs into products
                through suppliers and then publish them on their own websites and online stores for sale. The products
                will be directly produced, printed, and shipped to their customers by the suppliers .
              </div>
              <div
                class="btnBt"
                @click="
                  toBlog('https://www.printdoors.com/blog/print-on-demand-trends-how-to-be-creative-and-profitable/')
                "
              >Read more></div>
            </div>
          </div>
          <div
            class="blogItem"
            @click="
              toBlog('https://www.printdoors.com/blog/5-things-to-consider-before-starting-your-own-shopify-pod/')
            "
          >
            <div class="imgBox">
              <img
                loading="lazy"
                class="hoverImg"
                src="@/assets/homePage/blog_3.png"
                alt="fulfillment partner"
              >
            </div>
            <div class="blogTitle">5 Things To Consider Before Starting Your Own Shopify POD</div>
            <div class="blogTip">
              If you’re a creative person with a passion for personalized products, a POD shop might be the perfect
              venture for you. Not only do you get to express your creativity, but you also get to sell your products
              and make money from them. But before you run a risk and spend all that time and energy building up your
              store, there are several things to consider first. In this post, I’ll share some insight into what it
              takes to start your own Shopify POD business and how other people have done it successfully through their
              own experiences.
            </div>
            <div class="hoverWrap" @click.stop>
              <h1>5 Things To Consider Before Starting Your Own Shopify POD</h1>
              <div class="hoverTip">
                If you’re a creative person with a passion for personalized products, a POD shop might be the perfect
                venture for you. Not only do you get to express your creativity, but you also get to sell your products
                and make money from them. But before you run a risk and spend all that time and energy building up your
                store, there are several things to consider first. In this post, I’ll share some insight into what it
                takes to start your own Shopify POD business and how other people have done it successfully through
                their own experiences.
              </div>
              <div
                class="btnBt"
                @click="
                  toBlog('https://www.printdoors.com/blog/5-things-to-consider-before-starting-your-own-shopify-pod/')
                "
              >Read more></div>
            </div>
          </div>
        </div>
        <div class="blogBtn">
          <a href="https://www.printdoors.com/blog/" target="_blank">Read more></a>
        </div>
      </div>
    </div>
    <div class="email_input_wrap">
      <div class="mainWrap">
        <div class="title">BE IN TOUCH WITH US</div>
        <div
          class="second_title"
        >You'll also get the latest discounts, news and gift ideas sent to your inbox every week.</div>
        <div
          class="second_title"
          v-if="addPublicityRecordSuccess"
        >Thank you for joining our mailing list!</div>
        <div class="input_wrap">
          <a-input v-model="email" placeholder="Enter your email address..."></a-input>
          <a-button type="primary" @click="submitPublicityRecord">SIGN UP</a-button>
        </div>
      </div>
    </div>
    <div v-if="!getToken">
      <a href="/newcomer-gift" class="ev-fixed-entery">
        <span class="triangle"></span>
        <div class="text">
          <span class="top-text">$180 OFF</span>
          <div class="bottom-text">
            <span class="top-text">For New</span>
          </div>
        </div>
      </a>
    </div>
    <div v-if="!acceptCookie">
      <div class="cookie_wrap">
        <div class="title">But first cookies</div>
        <div class="content">
          we use essential cookies to make printdoors work we'd loke to use other cookies to improve and personalize
          your visit,tailor ads you see from us on printdoors and partner sites ,and to analyze our website's
          perormance.but only if you accept.learn more about your choices in
        </div>
        <a-button @click="acceptCookieMethod" type="primary">Accept all cookies</a-button>
      </div>
    </div>
    <DesignMobile v-if="token" ref="designMobileModal" @change="change"/>
    <a-modal
      width="1200px"
      class="homeModal"
      :visible="tcVisible"
      :footer="null"
      :closable="false"
      @cancel="tcVisibleFn"
      :getContainer="() => $refs.homeModal"
    >
      <div class="aboutWrap">
        <a class="close" @click="tcVisibleFn()">
          <img src="@/assets/homePage/tc_close.png">
        </a>
        <div class="infoBox" @click="toChristmas()">
          <img src="@/assets/homePage/home_tc.png">
        </div>
      </div>
    </a-modal>
    <a-modal
      width="1200px"
      class="valentinesDayModal"
      :maskClosable="false"
      :visible="valentinesDayVisible"
      :footer="null"
      :closable="false"
      @cancel="
        () => {
          cancelFn()
        }
      "
      :getContainer="() => $refs.homeModal"
    >
      <div class="aboutWrap">
        <a class="close" @click="cancelFn()">
          <!-- <img src="@/assets/christmas/summerSales/close.png"/> -->
          <!-- <img src="@/assets/christmas/stPatrickIsDay/close.png"> -->
          <img src="@/assets/christmas/easterGiftZone/close.png">
        </a>
        <div class="infoBox hover">
          <!-- <img @click="toValentinesDay" width="1400" src="@/assets/christmas/summerSales/tc_img.png" /> -->
          <!-- <img @click="toValentinesDay" width="1400" src="@/assets/homePage/time_tc.png" /> -->
          <!-- <img @click="toValentinesDay" width="710" src="@/assets/christmas/letThePartyBegin/tc_img.png" /> -->
          <!-- <img
            @click="toValentinesDay"
            width="1193"
            src="@/assets/christmas/stPatrickIsDay/tc_img.png"
          >-->
          <img
            width="1200"
            @click="toValentinesDay"
            src="@/assets/christmas/easterGiftZone/tc_img.png"
          >
        </div>
      </div>
    </a-modal>
    <a-modal
      width="1200px"
      class="motherIsDayModal"
      :maskClosable="false"
      :visible="motherIsDayVisible"
      :footer="null"
      :closable="false"
      @cancel="
        () => {
          motherIsDayCancel()
        }
      "
      :getContainer="() => $refs.homeModal"
    >
      <div class="motherIsDayAboutWrap">
        <a class="close" @click="motherIsDayCancel()"></a>
        <div class="infoBox">
          <img @click="toMotherIsDay" width="1200" src="@/assets/christmas/motherIsDay/tc_img.png">
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import './style/index.less'
import ProductList from '@/views/platformPage/components/productList'
import DesignMobile from '@/views/designMobile'
import Vue from 'vue'
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex'
import { ACCESS_TOKEN, ACCEPT_COOKIE } from '@/store/mutation-types'
import { getProductDetail } from '@/api/products'
import { addPublicityRecord } from '@/api/homePage'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import HotSale from './components/hotSale'
import HeadBanner from './components/headBanner'
export default {
  name: 'HomePage',
  data() {
    return {
      motherIsDayVisible: false,
      valentinesDayVisible: false,
      tcVisible: false,
      swiperOption: {
        slidesPerView: 1.4,
        slidesOffsetBefore: 240,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        autoplay: {
          delay: 4000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        loop: true
      },
      swiperOption1: {
        slidesPerView: 1.4,
        slidesOffsetBefore: 60,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        autoplay: {
          delay: 4000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        loop: true
      },
      howIndex: 1,
      cdSt: null,
      customerIndex: 0, // 人物介绍
      mbCustomerIndex: 0, // 移动端
      howItWorksList: [
        {
          imgSrc: require('@/assets/homePage/how_it_work_1.png'),
          mbImgSrc: require('@/assets/homePage/mb_how_1.png'),
          icon: require('@/assets/homePage/how_icon_1.png'),
          iconHover: require('@/assets/homePage/how_icon_hover_1.png'),
          content: 'Connect your store',
          descr: 'Easy to connect your online store with our integration tools.',
          alt: 'Connect your store'
        },
        {
          imgSrc: require('@/assets/homePage/how_it_work_2.png'),
          mbImgSrc: require('@/assets/homePage/mb_how_2.png'),
          icon: require('@/assets/homePage/how_icon_2.png'),
          iconHover: require('@/assets/homePage/how_icon_hover_2.png'),
          content: 'Design And Publish',
          descr: 'Create your own products using our simple design tools and add them to your store.',
          alt: 'Design And Publish'
        },
        {
          imgSrc: require('@/assets/homePage/how_it_work_3.png'),
          mbImgSrc: require('@/assets/homePage/mb_how_3.png'),
          icon: require('@/assets/homePage/how_icon_3.png'),
          iconHover: require('@/assets/homePage/how_icon_hover_3.png'),
          content: 'Sell Your Products',
          descr: 'Start selling your designs and let us handle the orders.',
          alt: 'Sell Your Products'
        },
        {
          imgSrc: require('@/assets/homePage/how_it_work_4.png'),
          mbImgSrc: require('@/assets/homePage/mb_how_4.png'),
          content: 'Fulfilled By PrintDoors',
          icon: require('@/assets/homePage/how_icon_4.png'),
          iconHover: require('@/assets/homePage/how_icon_hover_4.png'),
          descr: 'We take care of the order fulfillment and shipping so you can concentrate on growing your business.',
          alt: 'Fulfilled By PrintDoors'
        }
      ],
      storeList: [
        {
          imgSrc: require('@/assets/homePage/shopify.png'),
          alt: 'shopify print on demand',
          url:
            'https://apps.shopify.com/printdoors-print-on-demand?locale=zh-CN&search_id=0dfcce91-8e96-4d51-837b-276fc48c65e9&surface_detail=printdoors&surface_inter_position=1&surface_intra_position=2&surface_type=search'
        },
        {
          imgSrc: require('@/assets/homePage/etsy.png'),
          alt: 'etsy print on demand',
          url: 'https://www.etsy.com'
        },
        {
          imgSrc: require('@/assets/homePage/wooCommerce.png'),
          alt: 'woocommerce print on demand',
          url: 'https://wordpress.org/plugins/printdoors-for-woocommerce/'
        },
        {
          imgSrc: require('@/assets/homePage/shoplazza.png'),
          alt: 'shoplazza print on demand',
          url:
            'https://appstore.shoplazza.com/listing/50615/printdoors-pod-and-dropshipping-partner/?keyword=printdoors&page=1&order_by=most-installed&locale=zh-CN&utm_source=website_cn&_gl=1*854thq*_ga*MTYzMzcyNjEwMC4xNjY5Njg1Mjc3*_ga_5YE6EELEQ3*MTY2OTY4NTI5Ni4xLjEuMTY2OTY4NTMxMy40My4wLjA'
        }
      ],
      choosePrintdoorsList: [
        {
          imgSrc: require('@/assets/homePage/chosse_printdoors_1.png'),
          content: '100% Free Platform',
          descr: 'PrintDoors is 100% free to use with no hidden fees, monthly fees, or setup fees.',
          alt: 'best print on demand vendors'
        },
        {
          imgSrc: require('@/assets/homePage/chosse_printdoors_2.png'),
          content: 'Intuitive Design Tool',
          descr:
            'The super simple design tool allows you to create a design with our built-in maker tool, whether you have design experience or not.',
          alt: 'custom print design'
        },
        {
          imgSrc: require('@/assets/homePage/chosse_printdoors_3.png'),
          content: 'Reliable Quality',
          descr: 'Make a lasting impression with our industry-leading technology, quality inks, and premium materials.',
          alt: 'High quality customized products'
        },
        {
          imgSrc: require('@/assets/homePage/chosse_printdoors_4.png'),
          content: 'No Minimum Order',
          descr:
            'Enjoy the freedom to experiment with your store concept and products without worrying about minimum order requirements.',
          alt: 'dropshipping'
        },
        {
          imgSrc: require('@/assets/homePage/chosse_printdoors_5.png'),
          content: 'Fast Fulfillment',
          descr:
            'Design your personalized printing anytime and anywhere, and get your products fast with our fast fulfillment.',
          alt: 'printdoors dropship'
        },
        {
          imgSrc: require('@/assets/homePage/chosse_printdoors_6.png'),
          content: 'More than 9 technologies',
          descr:
            'Offer more than 9 cutting-edge technologies for the most professional manufacturing and printing services for your customized products.',
          alt: 'print on demand t-shirts'
        }
      ],
      imgList: [
        {
          imgSrc: require('@/assets/homePage/1.png'),
          title: 'print on demand Home & Living',
          alt:
            "custom Home Wall Decor、Decorative Pillows、Women's Clothing、Kids & Youth Clothing、Luggage & Bags 、Accessories  Outdoors、Pet Products",
          href: 'https://www.printdoors.com/products/category/home_living'
        },
        {
          imgSrc: require('@/assets/homePage/2.png'),
          title: 'print on demand men’s clothing',
          alt:
            "printed logo shirt, animal print shirt for men, full printed t shirts, customized t shirts for men shirt with design on back, custom print on demand clothing, custom Men's Clothing, print on demand clothing, printed logo shirt, black t shirts with print, cheetah print shirt men, customized t shirts for men",
          href: 'https://www.printdoors.com/products/category/men_s_clothing'
        },
        {
          imgSrc: require('@/assets/homePage/3.png'),
          title: "print on demand women's clothing",
          alt: 'custom Holiday Decor',
          href: 'https://www.printdoors.com/products/category/women_s_clothing'
        },
        {
          imgSrc: require('@/assets/homePage/4.png'),
          title: 'print on demand Holiday Decor',
          alt:
            "print on demand dresses, custom print t shirt,custom women's clothing, custom dresses online, print on demand swimwear, printed panties, plus size clothing print on demand, print on demand shirts",
          href: 'https://www.printdoors.com/products/category/pet_products'
        },
        {
          imgSrc: require('@/assets/homePage/5.png'),
          title: 'print on demand Pet Products',
          alt: "custom pet's scarf、pet bedding、pet's clothing",
          href: 'https://www.printdoors.com/products/category/holiday_decor'
        }
      ],
      customerOptionList: [
        {
          avatar: require('@/assets/homePage/op_1.png'),
          name: 'Raghid',
          tip: '(Canada)',
          score: 5,
          content:
            "I've been using Printdoors for 2 months so far, and here's my experience so far; - Quick and fast support for any issue. - Great Prices, all the products have great pricing, I order samples before setting them up on my store, and in comparison to other PODs, printdoors ships the fastest and has great quality. - Amazing service, I asked printdoors to send me images of products mid production and they happily did so, something that other PODs did not offer. - Easy to use UI and has great integration, I was able to sync multiple orders at once, and all I had to do was confirm payment and everything else was worry free, printdoors handled everything for me. I recommend printdoors to anyone looking for an honest POD service."
        },
        {
          avatar: require('@/assets/homePage/op_3.png'),
          name: 'Irina Lvovsky',
          tip: '(United States)',
          score: 5,
          content:
            "This store has the best customer service ever! Personal communication, all problems are resolved quickly. Prices are good, quality of print is good so far. I've ordered 25 backdrops for my client (did it in three orders), everything came up in very good quality except those where I made a mistake myself (have to remember for the future that one needs to print one's design first on paper and check if everything is visible - it's especially important for the darker designs). The backdrops were for the theater performance, and everyone mentioned how realistic they looked! I'm going to order other items and see if the quality stands, but so far, it was a very good experience!"
        },
        {
          avatar: require('@/assets/homePage/op_2.png'),
          name: 'Andrei',
          tip: '(Finland)',
          score: 5,
          content:
            "This is a really great supplier, and constantly improving, for example, the recent addition of branding options, and the absolute best customer service in the business. I have sampled the cotton AOP tshirt and hoodie, and 2 handbags, and they are top notch quality, from fabric to sewing and attention to details (the hoodie feels the best out of 3 other competitor's cotton hoodies, is nice and heavy and soft). As soon as i placed my order, Joanna contacted me and was really helpful with the logo's sizing and placement, and even provided me photos of the products before shipping. When one of my orders was stuck for a week in Germany (not PrintDoors fault, Joanna kept a really close eye to that order and kept me updated with every move, until i got it). You have to try it, they are shaping up to be a vicious competitor in the POD market."
        }
      ],
      productList: [
        {
          title: "Men's Wear",
          showSrc: require('@/assets/homePage/men_wear.jpg'),
          category: 'men_s_clothing',
          alt: 'Custom T-shirt'
        },
        {
          title: "Women's Clothing",
          showSrc: require('@/assets/homePage/women_clothing.jpg'),
          category: 'women_s_clothing',
          alt: 'Custom underwear'
        },
        {
          title: 'Outdoors',
          showSrc: require('@/assets/homePage/outdoor.jpg'),
          category: 'outdoors',
          alt: 'Custom beach towel'
        },
        {
          title: 'Pillow',
          showSrc: require('@/assets/homePage/pillow.png'),
          category: 'decorative_pillows',
          alt: 'Custom household products'
        },
        {
          title: 'Cup',
          showSrc: require('@/assets/homePage/cup.png'),
          category: 'cups',
          alt: 'Custom cup'
        },
        {
          title: 'Home & Living',
          showSrc: require('@/assets/homePage/holiday_supplies.png'),
          category: 'outdoors',
          alt: 'Custom metal plate'
        },
        {
          title: 'Phone Case',
          showSrc: require('@/assets/homePage/phone_case.png'),
          category: 'phone_cases',
          alt: 'Custom phone case'
        },
        {
          title: 'Bag',
          showSrc: require('@/assets/homePage/bag.png'),
          category: 'lunch_bag',
          alt: 'Custom luggage'
        }
      ],
      acceptCookie: false,
      desigeMobileNum: 0,
      detail: {},
      email: '',
      addPublicityRecordSuccess: false
    }
  },
  computed: {
    ...mapGetters(['getToken']),
    ...mapState({
      token: state => state.user.token
    })
  },
  components: { ProductList, DesignMobile, HeadBanner, HotSale, Swiper, SwiperSlide },
  watch: {},
  methods: {
    ...mapMutations(['SET_TOKEN']),
    ...mapActions(['GetInfo']),
    toMotherIsDay() {
      this.motherIsDayVisible = false
      this.$ls.set('motherIsDayVisible', true, 24 * 60 * 60 * 1000)
      this.$router.push('/activity/motherIsDay')
    },
    motherIsDayCancel() {
      this.motherIsDayVisible = false
      this.$ls.set('motherIsDayVisible', true, 24 * 60 * 60 * 1000)
    },
    toValentinesDay() {
      this.valentinesDayVisible = false
      this.$ls.set('valentinesDayVisible', true, 24 * 60 * 60 * 1000)
      // this.$router.push('/products/timeliness/1')
      // this.$router.push('/activity/bestSellersForSummer')
      // this.$router.push('/activity/stPatrickIsDay')
      this.$router.push('/activity/easterGiftZone')
    },
    cancelFn() {
      this.valentinesDayVisible = false
      this.$ls.set('valentinesDayVisible', true, 24 * 60 * 60 * 1000)
    },
    tcVisibleFn() {
      this.$ls.set('homeTcVisible', true, 24 * 60 * 60 * 1000)
      this.tcVisible = false
    },
    toChristmas() {
      this.$ls.set('homeTcVisible', true, 24 * 60 * 60 * 1000)
      this.tcVisible = false
      this.$router.push('/activity/customChristmas')
    },
    toBlog(url) {
      window.open(url, '_blank')
    },
    toLogin() {
      if (!this.getToken) {
        this.$router.push('/user/login?type=2')
      } else {
        this.$router.push('/products')
      }
    },
    changeIndex(index, n) {
      if (n === 1) {
        const swiper = this.$refs.myMbSwiper.$swiper
        console.log('index====', index)

        swiper.slideTo(index + 1)
      } else {
        const swiper = this.$refs.myPcSwiper.$swiper
        console.log('index====pc', index)

        swiper.slideTo(index + 1)
        swiper.update()
      }
    },
    cdstFn() {
      if (this.howIndex === this.howItWorksList.length - 1) {
        this.howIndex = 0
      } else {
        this.howIndex++
      }
    },
    cdstClick(i) {
      clearInterval(this.cdSt)
      this.howIndex = i
      this.cdSt = setInterval(() => {
        this.cdstFn()
      }, 3000)
    },
    goDesign() {
      // this.show = true
      this.$router.push({ path: '/design/design' })
    },
    toDesignMobile() {
      if (!this.token) {
        this.$router.push('/user/login')
      } else {
        getProductDetail({ id: 1954 }).then(res => {
          const detail = res.data
          const { designMobileModal } = this.$refs
          designMobileModal.src = detail.print_areas[0].image_src
          designMobileModal.allShowImgs = detail.show_images_design
          designMobileModal.activeColor = detail.colors[0].id
          designMobileModal.sizeId = detail.sizes[0].id
          designMobileModal.show = true
          designMobileModal.productId = detail.id
          designMobileModal.is_3d = detail.is_3d
          this.$nextTick(() => {
            this.desigeMobileNum === 0 && designMobileModal.resize()
            this.desigeMobileNum++
          })
        })
      }
    },
    mouseOver(item) {
      item.showSrc = item.hoverImgSrc
    },
    mouseOut(item) {
      item.showSrc = item.imgSrc
    },
    acceptCookieMethod() {
      Vue.ls.set(ACCEPT_COOKIE, true, 30 * 24 * 60 * 60 * 1000)
      this.acceptCookie = true
    },
    openProducts(url) {
      window.open(url, '_blank')
    },
    submitPublicityRecord() {
      addPublicityRecord({
        type: 2,
        email: this.email
      }).then(res => {
        this.addPublicityRecordSuccess = true
        this.email = ''
      })
    }
  },
  mounted() {
    this.cdSt = setInterval(() => {
      this.cdstFn()
    }, 3000)
    if (this.$route.query.token) {
      Vue.ls.set(ACCESS_TOKEN, this.$route.query.token, 7 * 24 * 60 * 60 * 1000)
      this.SET_TOKEN(this.$route.query.token)
      // if (this.$ls.get(THIRD_LOGIN_REDIRECT)) {
      //   this.$router.push(this.$ls.get(THIRD_LOGIN_REDIRECT))
      // } else {
      //   this.$ls.remove(THIRD_LOGIN_REDIRECT)
      // }
      this.GetInfo()
    }
    this.acceptCookie = Vue.ls.get(ACCEPT_COOKIE)
    // this.$nextTick(() => {
    //   if (!this.$ls.get('homeTcVisible')) {
    //     this.tcVisible = true
    //   }
    // })
    this.$nextTick(() => {
      if (!this.$ls.get('valentinesDayVisible')) {
        this.valentinesDayVisible = true
      }
    })
  },
  destroyed() {}
}
</script>

<style lang="less" scoped>
@keyframes show {
  0% {
    opacity: 0;
    display: inline;
  }
  100% {
    opacity: 1;
  }
}
@keyframes hidden {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    display: none;
  }
}
.homepageWrap {
  position: relative;
  /deep/.homeModal {
    .ant-modal-content {
      padding: 0px !important;
      background: transparent !important;
      box-shadow: none !important;
    }
    .ant-modal-body {
      padding: 0px 0px 20px 56px !important;
      background: url('../../assets/homePage/home_tc_bg.png') left top no-repeat;
      background-size: cover;
    }
    .aboutWrap {
      position: relative;
      .close {
        position: absolute;
        right: 79px;
        top: 23px;
        z-index: 1;
      }
      .infoBox {
        overflow: hidden;
        img {
          max-width: 100%;
          cursor: pointer;
        }
      }
    }
  }
  /deep/.mainWrap {
    width: 1400px;
    margin: 0 auto;
    .comTitle {
      margin: 0;
      font-size: 48px;
      color: #333333;
      font-weight: bold;
      color: #333333;
      text-align: center;
      span {
        color: #f48900;
      }
    }
    .comH2 {
      margin: 0;
      font-size: 60px;
      color: #333333;
      font-weight: bold;
      color: #333333;
      text-align: center;
    }
    .comTitTip {
      margin: 10px 0 0 0;
      padding: 0 210px;
      font-size: 20px;
      font-weight: 400;
      color: #666666;
      line-height: 28px;
      text-align: center;
    }
  }
  .headWrap {
    // background: url('../../assets/homePage/head_bg.png') center top no-repeat;
  }
  .banner_wrap {
    padding: 40px 260px;
    display: flex;
    flex-flow: row;
    justify-content: center;
    height: 550px;
    overflow: hidden;
    .banner_left {
      display: flex;
      flex-flow: column;
      justify-content: center;
      width: 758px;
    }
    // .rightWrap {
    //   position: relative;
    //   overflow: hidden;
    //   padding: 0 10px;
    //   height: 100%;
    //   .maskBox {
    //     position: absolute;
    //     left: 0;
    //     right: 0;
    //     height: 80px;
    //     z-index: 2;
    //     &.top {
    //       top: 0;
    //       background: linear-gradient(top, #fff 0%, rgba(23, 113, 248, 0) 100%);
    //     }
    //     &.bt {
    //       bottom: 0;
    //       background: linear-gradient(bottom, #fff 0%, rgba(23, 113, 248, 0) 100%);
    //     }
    //   }
    //   .bnRtBox {
    //     display: flex;
    //     justify-content: space-between;
    //     animation-play-state: running;
    //     -webkit-animation-play-state: running;
    //     -webkit-animation: home-scroll-grid-infinite 40s linear 0s infinite;
    //     animation: home-scroll-grid-infinite 40s linear 0s infinite;
    //     &:hover {
    //       animation-play-state: paused;
    //       -webkit-animation-play-state: paused;
    //     }
    //     .bnRtImg {
    //       overflow: hidden;
    //       margin-bottom: 16px;
    //       width: 173px;
    //       height: 221px;
    //       border-radius: 24px;
    //       cursor: pointer;
    //       transition: transform 0.3s;
    //       &.cp_1 {
    //         background: url('../../assets/homePage/banner/cp_1.png') center center no-repeat;
    //       }
    //       &.cp_2 {
    //         background: url('../../assets/homePage/banner/cp_2.png') center center no-repeat;
    //       }
    //       &.cp_3 {
    //         background: url('../../assets/homePage/banner/cp_3.png') center center no-repeat;
    //       }
    //       &.cp_4 {
    //         background: url('../../assets/homePage/banner/cp_4.png') center center no-repeat;
    //       }
    //       &.cp_5 {
    //         background: url('../../assets/homePage/banner/cp_5.png') center center no-repeat;
    //       }
    //       &.cp_6 {
    //         background: url('../../assets/homePage/banner/cp_6.png') center center no-repeat;
    //       }
    //       &.cp_7 {
    //         background: url('../../assets/homePage/banner/cp_7.png') center center no-repeat;
    //       }
    //       &.cp_8 {
    //         background: url('../../assets/homePage/banner/cp_8.png') center center no-repeat;
    //       }
    //       &.cp_9 {
    //         background: url('../../assets/homePage/banner/cp_9.png') center center no-repeat;
    //       }
    //       &.cp_10 {
    //         background: url('../../assets/homePage/banner/cp_10.png') center center no-repeat;
    //       }
    //       &.cp_11 {
    //         background: url('../../assets/homePage/banner/cp_11.png') center center no-repeat;
    //       }
    //       &.cp_12 {
    //         background: url('../../assets/homePage/banner/cp_12.png') center center no-repeat;
    //       }
    //       &:hover {
    //         transform: scale(1.08);
    //         box-shadow: 0 5px 20px 0 rgba(0 0 0, 0.1);
    //       }
    //       &.mt70 {
    //         margin-top: -170px;
    //       }
    //       &.mt50 {
    //         margin-top: -120px;
    //       }
    //     }
    //   }
    // }
    .banner_right {
      display: none;
      img {
        width: 700px;
      }
    }
  }
  /deep/.activityBlock {
    padding-top: 100px;
    // background: url('../../assets/homePage/filterBg.png') center -20px no-repeat;
    .activityFlex {
      display: flex;
      margin: 0 -8px;
      .activityItem {
        position: relative;
        width: 362px;
        cursor: pointer;
        pointer-events: initial;
        img {
          max-width: 100%;
        }
        .soon {
          position: absolute;
          left: 8px;
          top: 5px;
          right: 20px;
          bottom: 12px;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: end;
          padding-bottom: 20px;
          justify-content: center;
          z-index: 1;
          span {
            font-size: 38px;
            color: #fff;
          }
        }
      }
    }
  }
  /deep/.how_it_works {
    position: relative;
    width: 1400px;
    margin-top: 90px;
    padding: 0px 0 50px 0;
    pointer-events: initial;
    z-index: 9;
    .howWrap {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding-top: 80px;
    }
    .howItem {
      width: 456px;
      height: 200px;
      background: #fff4e7;
      border-radius: 8px;
      text-align: center;
      img {
        margin-top: -42px;
      }
      .howTip {
        padding: 14px;
        font-size: 20px;
        font-family: Segoe UI-Regular, Segoe UI;
        font-weight: 400;
        color: #666666;
      }
    }
    .howBtn {
      padding-top: 32px;
      text-align: center;
      a {
        display: inline-block;
        width: 338px;
        height: 60px;
        background: #fff4e7;
        border-radius: 4px 4px 4px 4px;
        line-height: 60px;
        font-size: 16px;
        font-weight: bold;
        color: #f48900;
      }
    }
  }
  .custmozie_img_list {
    padding: 40px 240px;
    display: flex;
    flex-wrap: wrap;
    img {
      margin-top: 16px;
    }
  }
  .pc_why_choose {
    padding: 20px 0 70px 0;
    .chooseWrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .tabItem {
        width: 574px;
        height: 102px;
        margin-top: 36px;
        display: flex;
        padding: 0 43px;
        align-items: center;
        background: #ffffff;
        box-shadow: 0px 12px 26px 1px #fef4e7;
        border-radius: 8px 8px 8px 8px;
        font-family: Source Han Sans CN-Bold, Source Han Sans CN;
        font-size: 32px;
        font-weight: bold;
        color: #333333;
        cursor: pointer;
        .iconSp {
          padding-right: 27px;

          .hoverIcon {
            display: none;
          }
        }
        &.on {
          color: #fff;
          background: linear-gradient(185deg, #ffb300 0%, #f48900 100%);
          .curIcon {
            display: none;
          }
          .hoverIcon {
            display: inline-block;
          }
        }
      }
      .infoRt {
        position: relative;
        overflow: hidden;
        width: 750px;
        padding-top: 76px;
        white-space: nowrap;
        height: 459px;
        .scrollWrap {
          display: inline-block;
          transition: all 0.3s;
          .infoItem {
            display: inline-block;
            padding: 0 43px;
            width: 750px;
            height: 383px;
            text-align: center;
            background: #fff4e7;
            img {
              margin-top: -76px;
            }
            .tipWrap {
              margin-top: 32px;
              font-size: 24px;
              font-weight: 400;
              color: #333333;
              line-height: 31px;
              white-space: normal;
            }
          }
        }
        .scrollTba {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 30px;
          z-index: 1;
          text-align: center;
          span {
            display: inline-block;
            width: 43px;
            height: 10px;
            margin: 0 6px;
            background: #fff;
            cursor: pointer;
            &.on {
              background: #f48900;
            }
          }
        }
      }
    }
  }
  .mb_why_choose {
    display: none;
  }
  .productBlock {
    padding: 110px 0;
    background: #fff4e7;
    .product_wrap {
      .product_list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 60px;
        .product {
          display: flex;
          flex-flow: column;
          justify-content: center;
          align-items: center;
          width: 338px;
          height: 400px;
          margin-top: 16px;
          .img-wrap {
            position: relative;
            height: 338px;
            width: 338px;
            background: #ffffff;
            cursor: pointer;
            img {
              width: 100%;
              transition: all 0.3s ease-in-out;
              animation: show;
              // position: absolute;
              // left: 50%;
              // top: 50%;
              // transform: translate(-50%, -50%);
            }
          }
          .name {
            margin-top: 20px;
            font-size: 24px;
            font-weight: 400;
            color: #999999;
          }

          // .hoverImg {
          //   display: none;
          //   opacity: 0;
          // }
          // &:hover {
          //   cursor: pointer;
          //   .hoverImg {
          //     opacity: 1;
          //     display: inline-block;
          //   }
          //   .img {
          //     opacity: 0;
          //     display: none;
          //   }
          // }
        }
      }
      .view_all_button {
        width: 240px;
        height: 40px;
        background: #ffa200;
        margin-top: 20px;
        box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
        opacity: 1;
        border-radius: 8px;
      }
    }
    .moreWrap {
      width: 100%;
      text-align: center;
      margin-top: 77px;
      a {
        display: inline-block;
        padding: 0 50px;
        height: 60px;
        background: linear-gradient(180deg, #ffb300 0%, #f48900 100%);
        box-shadow: 0px 12px 26px 1px #f9c684;
        border-radius: 8px 8px 8px 8px;
        font-size: 16px;
        font-weight: bold;
        color: #ffffff;
        line-height: 60px;
      }
    }
  }

  .integration_options {
    padding: 110px 0;
    background: #fff;
    .store_list {
      margin-top: 64px;
      display: flex;
      flex-flow: row;
      justify-content: space-between;
      align-items: center;
      .store {
        position: relative;
        width: 322px;
        height: 190px;
        background: #ffffff;
        box-shadow: 0px 12px 26px 1px #fef4e7;
        border-radius: 16px 16px 16px 16px;
        display: flex;
        align-items: center;
        img {
          width: 100%;
        }
        .tip_icon {
          font-size: 18px;
          color: #999999;
          position: absolute;
          right: 10px;
          top: 10px;
        }
      }
    }
  }
  .choose_printdoors {
    padding: 110px 0;
    background: #fff4e7;
    .choose_printdoors_list {
      padding-top: 20px;
      display: flex;
      flex-flow: row;
      justify-content: space-between;
      flex-wrap: wrap;
      .choose_printdoors_item {
        width: 692px;
        height: 320px;
        margin-top: 20px;
        padding: 28px;
        background: #ffffff;
        text-align: center;
        // word-break: break-all;
        .chooseTit {
          margin-top: 20px;
          font-size: 32px;
          font-weight: bold;
          color: #333333;
          line-height: 1;
        }
        .chooseTip {
          margin-top: 20px;
          font-size: 24px;
          font-weight: 400;
          color: #333333;
        }
      }
    }
  }
  .signUp {
    background: linear-gradient(0deg, #fff 0%, #fff 60%, #fff4e7 60%, #fff4e7 100%);
    text-align: center;
    img {
      cursor: pointer;
    }
    .mb_sign {
      display: none;
    }
  }
  .customers_option {
    background: #fff;
    padding: 110px 0;
    &.mb_customers_option {
      display: none;
    }
    .customer_option_list {
      padding-top: 30px;
      .scrollWrap {
        display: inline-block;
        transition: all 0.3s;
      }
      .swiperWrap {
        padding: 30px 20px;
      }
      .customers_option_item {
        padding: 28px;
        width: 100%;
        height: 360px;
        border: 2px solid #f48900;
        background: #ffffff;
        box-shadow: 0px 5px 10px 1px #ffe3be;
        border-radius: 20px;
        background-repeat: no-repeat;
        background-position: right bottom;
        background-size: auto 100%;
        .avatar_wrap {
          .name {
            font-size: 28px;
            font-weight: bold;
            color: #333333;
            span {
              font-size: 19px;
              color: #333;
              font-weight: 500;
            }
          }
          .star_wrap {
            margin-top: 8px;
            display: flex;
          }
        }
        .customer_option_content {
          width: 80%;
          margin-top: 26px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 26px;
          white-space: normal;
          text-align: justify;
        }
      }
      /deep/.swiper-container {
        padding-bottom: 20px;
        .swiper-slide {
          transform: scale(1, 0.9);
          &.swiper-slide-active {
            transform: scale(1);
          }
        }
        .swiper-pagination {
          bottom: 0;
          z-index: 99;
          .swiper-pagination-bullet {
            width: 43px;
            height: 10px;
            background: #eee !important;
            border-radius: 0;
            opacity: 1 !important;
            &.swiper-pagination-bullet-active {
              background: #f48900 !important;
            }
          }
        }
      }
    }
  }
  .hot_sale {
    padding: 110px 0;
    background: #fff4e7;
  }
  .blog_block {
    padding: 110px 0;
    .blogWrap {
      margin-top: 30px;
      display: flex;
      justify-content: space-between;
      .blogItem {
        overflow: hidden;
        position: relative;
        width: 456px;
        height: 385px;
        background: #ffffff;
        box-shadow: 0px 12px 26px 1px #ffe3be;
        border-radius: 8px;
        cursor: pointer;
        .imgBox {
          overflow: hidden;
          height: 182px;
          display: flex;
          align-items: center;
          img {
            width: 100%;
          }
        }
        .blogTitle {
          padding: 0 20px;
          margin: 6px 0;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          word-break: break-all;
          font-size: 24px;
          font-weight: bold;
          color: #333333;
          line-height: 32px;
        }
        .blogTip {
          padding: 0 20px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          -webkit-line-clamp: 3;
          font-size: 16px;
          font-weight: 400;
          color: #999999;
          line-height: 32px;
          text-align: justify;
        }
        .hoverWrap {
          display: none;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(255, 255, 255, 0.8);
          z-index: 9;
          h1 {
            overflow: hidden;
            padding: 24px 20px 0 20px;
            margin: 0;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            word-break: break-all;
            font-size: 20px;
            font-weight: bold;
            color: #333333;
            line-height: 32px;
          }
          .hoverTip {
            overflow: hidden;
            padding: 6px 20px;
            font-size: 16px;
            font-family: Source Han Sans CN-Normal, Source Han Sans CN;
            font-weight: 400;
            color: #999999;
            line-height: 32px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            text-overflow: ellipsis;
            -webkit-line-clamp: 7;
            text-align: justify;
          }
          .btnBt {
            position: absolute;
            left: 0;
            bottom: 0;
            right: 0;
            height: 58px;
            background: linear-gradient(180deg, #ffb300 0%, #f48900 100%);
            border-radius: 0px 0px 8px 8px;
            font-size: 16px;
            font-weight: bold;
            color: #ffffff;
            line-height: 58px;
            text-align: center;
            z-index: 1;
          }
        }
        &:hover {
          .hoverWrap {
            display: block;
          }
          .hoverImg {
            position: absolute;
            left: 50%;
            top: 50%;
            height: 100%;
            width: auto;
            transform: translate(-50%, -50%);
            z-index: 8;
          }
        }
      }
    }
    .blogBtn {
      padding-top: 60px;
      text-align: center;
      a {
        display: inline-block;
        width: 338px;
        height: 60px;
        border-radius: 4px;
        font-size: 16px;
        font-weight: bold;
        color: #f48900;
        line-height: 60px;
        background: #fff4e7;
        cursor: pointer;
      }
    }
  }
  .get_start {
    padding: 20px 260px;
    height: 285px;
    background: linear-gradient(to bottom, #fafafa 0%, #fafafa 50%, #ffffff 50.01%, #ffffff 100%);
    .get_start_content {
      display: flex;
      flex-flow: row;
      justify-content: space-between;
      align-items: center;
      padding: 48px 140px;
      height: 245px;
      background: -webkit-linear-gradient(top, #ffc400, #ff6600);
      border-radius: 40px;
      cursor: pointer;
      .content {
        width: 454px;
        font-size: 52px;
        font-family: Source Han Sans SC;
        font-weight: 800;
        color: #ffffff;
      }
      .alike_button {
        width: 240px;
        height: 60px;
        font-size: 24px;
        line-height: 60px;
        text-align: center;
        color: #ffa200;
        background: #ffffff;
        box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
        border-radius: 8px;
      }
    }
  }
  .email_input_wrap {
    padding: 70px 0;
    background: #fff4e7;
    text-align: center;
    .title {
      font-size: 48px;
      font-weight: bold;
      color: #333333;
    }
    .second_title {
      font-size: 20px;
      font-weight: 400;
      color: #666666;
      margin-top: 8px;
    }
    .input_wrap {
      display: flex;
      justify-content: center;
      margin-top: 24px;
      input {
        width: 420px;
        height: 60px;
        border-radius: 8px;
      }
      button {
        background: #ffa200;
        height: 60px;
        margin-left: 20px;
        border-radius: 8px;
        font-size: 20px;
      }
    }
  }
}
.ev-fixed-entery {
  position: fixed;
  width: 186px;
  height: 99px;
  right: 0;
  bottom: 250px;
  display: flex;
  align-items: center;
  padding: 6px 10px;
  background: #ffa200;
  border-radius: 50px 0px 0px 50px;
  color: #fff !important;
  text-align: center;
  z-index: 99;
  .triangle {
    display: block;
    margin-left: 35px;
    margin-right: 12px;
    height: 0;
    border-top: 15px solid rgba(0, 0, 0, 0);
    border-bottom: 15px solid rgba(0, 0, 0, 0);
    border-left: 25px solid #fff;
  }
  .text {
    display: flex;
    flex-direction: column;
    font-size: 20px;
    font-weight: 500;
  }
  .top-text {
    white-space: nowrap;
  }
  .bottom-text {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.cookie_wrap {
  width: 73%;
  background: #ffa200;
  opacity: 1;
  border-radius: 16px;
  position: fixed;
  bottom: 10px;
  left: 13%;
  padding: 20px 40px;
  z-index: 99;
  opacity: 1;
  .title {
    font-size: 24px;
    color: #ffffff;
    font-weight: bold;
  }
  .content {
    font-size: 14px;
    font-weight: 400;
    margin: 12px 0;
    color: #ffffff;
  }
  /deep/.ant-btn {
    width: 260px;
    height: 40px;
    background: #ffba41;
    font-size: 14px;
  }
}
.design_button_mobile {
  display: none;
}
/deep/.valentinesDayModal {
  top: auto !important;
  .ant-modal-content {
    padding: 0;
    background: transparent !important;
    box-shadow: none !important;
  }
  .ant-modal-body {
    padding: 0 !important;
  }
  .aboutWrap {
    position: relative;
    .close {
      position: absolute;
      // right: 30px;
      // top: 40px;
      // right: 80px;
      // top: 64px;
      right: 0px;
      top: 106px;
      z-index: 9;
    }
    .tc_btn {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 20%;
      margin: 0 auto;
      z-index: 8;
      cursor: pointer;
    }

    .infoBox {
      overflow: hidden;
      text-align: center;
    }
    img {
      max-width: 100%;
    }
  }
}
@media screen and (max-width: 960px) {
  .design_button {
    display: none;
  }
  .design_button_mobile {
    display: block;
  }
  .cookie_wrap {
    width: 95%;
    left: 50%;
    transform: translate(-50%, 0);
    bottom: 12px;
    padding: 20px;
  }
  .ev-fixed-entery {
    position: fixed;
    width: 100px;
    height: 40px;
    right: 0;

    bottom: 250px;
    display: flex;
    align-items: center;
    padding: 6px 10px;
    background: #ffa200;
    border-radius: 50px 0px 0px 50px;
    color: #fff !important;
    text-align: center;
    z-index: 99;
    .triangle {
      display: block;
      margin-left: 10px;
      margin-right: 12px;
      height: 0;
      border-top: 5px solid rgba(0, 0, 0, 0);
      border-bottom: 5px solid rgba(0, 0, 0, 0);
      border-left: 10px solid #fff;
    }
    .text {
      display: flex;
      flex-direction: column;
      font-size: 10px;
      font-weight: 500;
    }
    .top-text {
      white-space: nowrap;
    }
    .bottom-text {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .homepageWrap {
    // padding: 16px;
    .headWrap {
      background: #fff;
    }
    /deep/.homeModal {
      .ant-modal-body {
        padding: 0px 0px 10px 10px !important;
      }
      .aboutWrap {
        position: relative;
        .close {
          position: absolute;
          right: 8px;
          top: 9px;
          z-index: 1;
          img {
            width: 30px;
          }
        }
        .infoBox {
          overflow: hidden;
          img {
            max-width: 100%;
            cursor: pointer;
          }
        }
      }
    }
    /deep/.mainWrap {
      width: 100%;
      .comTitle {
        position: relative;
        padding-bottom: 8px;
        font-size: 20px;
        &::before {
          position: absolute;
          content: '';
          bottom: 0;
          left: 50%;
          width: 86px;
          height: 4px;
          margin-left: -43px;
          background: #f48900;
          z-index: 1;
        }
      }
      .comH2 {
        position: relative;
        padding-bottom: 8px;
        font-size: 22px;
        &::before {
          position: absolute;
          content: '';
          bottom: 0;
          left: 50%;
          width: 86px;
          height: 4px;
          margin-left: -43px;
          background: #f48900;
          z-index: 1;
        }
      }
      .comTitTip {
        padding: 0;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        line-height: 18px;
      }
    }
    .banner_wrap {
      padding: 16px;
      flex-direction: column;
      justify-content: space-between;
      position: relative;
      margin-bottom: 80px;
      .banner_left {
        text-align: center;
        width: 100%;
        height: auto;
        > p {
          font-size: 14px !important;
          margin: 0;
        }
        > p:nth-child(1) {
          height: auto !important;
          font-size: 18px !important;
          width: 100% !important;
          margin-bottom: 32px;
        }
        /deep/.ant-btn {
          position: absolute;
          bottom: -60px;
          height: 50px !important;
          width: 100% !important;
          font-size: 16px !important;
        }
      }
      .rightWrap {
        display: none;
      }
      .banner_right {
        display: block;
        width: 100%;
        > img {
          height: auto;
          width: 100%;
        }
      }
    }
    > div:nth-child(2) {
      font-size: 24px !important;
      height: auto !important;
      margin-bottom: 18px;
    }
    > div:nth-child(4) {
      font-size: 24px !important;
      height: auto !important;
      margin-bottom: 18px;
    }
    > p {
      margin: 0;
      font-size: 14px;
      color: #999999;
    }
    /deep/.activityBlock {
      width: 100%;
      padding: 0px 16px;
      margin-bottom: 20px;

      .activityFlex {
        flex-wrap: wrap;
        .activityItem {
          position: relative;
          width: 50%;
          img {
            max-width: 100%;
          }
          .soon {
            position: absolute;
            left: 4px;
            top: 4px;
            right: 6px;
            bottom: 6px;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            align-items: end;
            padding-bottom: 6px;
            justify-content: center;
            z-index: 1;
            span {
              font-size: 22px;
              color: #fff;
            }
          }
        }
      }
    }
    /deep/.how_it_works {
      position: relative;
      width: 100%;
      margin-top: 0;
      padding: 0px 16px;
      z-index: 2;
      .howWrap {
        padding-top: 16px;
      }
      .howItem {
        position: relative;
        overflow: hidden;
        width: 100%;
        height: 70px;
        margin-top: 4px;
        border-radius: 0;

        &.sell {
          text-align: right;
          .howTip {
            justify-content: right;
            background: url('../../assets/homePage/mb_selling.png') left bottom no-repeat;
          }
        }
        &.car {
          text-align: left;

          .howTip {
            padding-right: 46px;
            background: url('../../assets/homePage/mb_car.png') right bottom no-repeat;
          }
        }
        &.book {
          text-align: left;

          .howTip {
            padding-left: 46px;
            background: url('../../assets/homePage/mb_book.png') left bottom no-repeat;
          }
        }
        img {
          display: none;
        }
        .howTip {
          position: relative;
          display: flex;
          align-items: center;
          width: 100%;
          height: 70px;
          padding: 8px;
          font-size: 12px;
          line-height: 18px;
          z-index: 1;
        }
      }
      .howBtn {
        display: none;
      }
    }
    .custmozie_img_list {
      padding: 10px 0 0 50px;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      div {
        width: 30%;
        img {
          margin-top: 16px;
          width: 100%;
        }
      }
      > div:nth-child(4) {
        width: 47%;
      }
      > div:nth-child(5) {
        width: 47%;
      }
    }
    .pc_why_choose {
      display: none;
    }
    .mb_why_choose {
      padding: 30px 16px;
      display: block;
      .mbChooseItem {
        padding: 12px 0;
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        .imgBox {
          img {
            width: 128px;
          }
        }
        .infoBox {
          h5 {
            margin: 0;
            font-size: 16px;
            font-weight: bold;
            color: #333333;
          }
          p {
            margin: 0;
            font-size: 12px;
            font-weight: 400;
            color: #333333;
            line-height: 16px;
          }
        }

        &:nth-child(odd) {
          .infoBox {
            padding-left: 20px;
            text-align: left;
          }
        }
        &:nth-child(even) {
          flex-direction: row-reverse;
          .infoBox {
            padding-right: 20px;
            text-align: right;
          }
        }
      }
    }
    .productBlock {
      padding: 30px 16px;
      background: #fff4e7;
      .product_wrap {
        .product_list {
          margin-top: 20px;
          .product {
            position: relative;
            width: 48%;
            height: auto;
            margin-top: 16px;
            .img-wrap {
              width: 100%;
              height: auto;
              border-radius: 4px;
            }
            .name {
              position: absolute;
              left: 0;
              bottom: 0;
              right: 0;
              margin: 0;
              padding: 10px 0;
              font-size: 16px;
              font-weight: 400;
              line-height: 1;
              color: #ffffff;
              background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%);
              border-radius: 0px 0px 4px 4px;
              text-align: center;
            }
          }
        }
        .view_all_button {
          width: 240px;
          height: 40px;
          background: #ffa200;
          margin-top: 20px;
          box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
          opacity: 1;
          border-radius: 8px;
        }
      }
      .moreWrap {
        margin-top: 20px;
        a {
          display: inline-block;
          padding: 0 25px;
          height: 40px;
          line-height: 40px;
          box-shadow: 0px 3px 15px #f9c684;
        }
      }
    }
    .integration_options {
      padding: 30px 16px;
      flex-direction: column;
      align-items: stretch;
      .store_list {
        margin-top: 20px;
        flex-wrap: wrap;
        .store {
          width: 48%;
          height: 94px;
          margin-top: 12px;
          box-shadow: 0px 4px 8px 1px #fef4e7;
          border-radius: 4px 4px 4px 4px;
        }
      }
    }
    .choose_printdoors {
      padding: 30px 16px;
      background: #fff;
      .choose_printdoors_list {
        padding-top: 12px;
        .choose_printdoors_item {
          width: 48%;
          height: 200px;
          margin-top: 12px;
          padding: 12px 8px;
          background: #fff4e7;
          box-shadow: 0px 3px 6px 1px #fff4e7;
          border-radius: 4px;
          text-align: center;
          .imgBox {
            img {
              width: 40px;
            }
          }
          .chooseTit {
            margin-top: 10px;
            font-size: 16px;
            font-weight: bold;
            color: #333333;
            line-height: 1;
            &.mt {
              margin-top: 4px;
            }
          }
          .chooseTip {
            margin-top: 10px;
            font-size: 12px;
            font-weight: 400;
            color: #999;
            line-height: 16px;
            &.mt {
              margin-top: 4px;
            }
          }
        }
      }
    }
    .signUp {
      padding: 0 16px;
      background: linear-gradient(0deg, #fff4e7 0%, #fff4e7 50%, #fff 50%, #fff 100%);
      img {
        max-width: 100%;
      }
      .pc_sign {
        display: none;
      }
      .mb_sign {
        display: block;
      }
    }
    .customers_option {
      padding: 30px 16px;
      background: #fff4e7;
      &.pc_customers_option {
        display: none;
      }
      &.mb_customers_option {
        display: block;
      }
      .customer_option_list {
        width: 100%;
        .swiperWrap {
          padding: 30px 10px 20px 10px;
        }
        .customers_option_item {
          padding: 12px;
          width: 100%;
          height: 240px;
          background: #ffffff;
          box-shadow: 0px 5px 10px #ffe3be;
          border-radius: 8px 8px 8px 8px;
          background-repeat: no-repeat;
          background-position: right top;
          background-size: 50% auto;
          .avatar_wrap {
            .name {
              font-size: 14px;
              font-weight: bold;
              color: #333333;
              span {
                font-size: 12px;
                font-weight: 500;
              }
            }
            .star_wrap {
              margin-top: 0px;
              display: flex;
            }
          }
          .customer_option_content {
            margin-top: 8px;
            font-size: 12px;
            font-weight: 400;
            width: 90%;
            color: #333333;
            line-height: 16px;
            white-space: normal;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            text-overflow: ellipsis;
            -webkit-line-clamp: 8;
            word-break: break-all;
          }
        }
      }
    }

    .hot_sale {
      padding: 30px 16px;
    }
    .blog_block {
      padding: 30px 16px;
      background: #fff4e7;
      .blogWrap {
        margin-top: 0px;
        flex-wrap: wrap;
        .blogItem {
          overflow: hidden;
          margin-top: 16px;
          padding-bottom: 20px;
          width: 100%;
          height: auto;
          background: #ffffff;
          box-shadow: 0px 4px 8px 1px #ffe3be;
          border-radius: 8px;
          cursor: pointer;
          .imgBox {
            height: auto;
            img {
              width: 100%;
            }
          }
          .blogTitle {
            padding: 0 20px;
            margin: 6px 0;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            word-break: break-all;
            font-size: 24px;
            font-weight: bold;
            color: #333333;
            line-height: 32px;
          }
          .blogTip {
            padding: 0 20px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            text-overflow: ellipsis;
            -webkit-line-clamp: 3;
            text-align: justify;
            font-size: 16px;
            font-weight: 400;
            color: #999999;
            line-height: 32px;
          }
          &:hover {
            .hoverWrap {
              display: none;
            }
            .hoverImg {
              position: initial;
              left: 50%;
              top: 50%;
              height: auto;
              width: 100%;
              transform: translate(0, 0);
              z-index: 8;
            }
          }
        }
      }
      .blogBtn {
        padding-top: 20px;
        a {
          display: inline-block;
          width: 100%;
          height: 40px;
          border-radius: 4px;
          font-size: 16px;
          font-weight: bold;
          color: #fff;
          line-height: 40px;
          height: 40px;
          background: linear-gradient(180deg, #ffb300 0%, #f48900 100%);
          cursor: pointer;
        }
      }
    }
    .get_start {
      padding: 0;
      margin-top: 30px;
      .get_start_content {
        padding: 32px 90px;
        flex-direction: column;
        .content {
          width: 100%;
          text-align: center;
          font-size: 20px;
          white-space: wrap;
        }
        .alike_button {
          font-size: 16px;
          color: #ff9e00;
        }
      }
    }
    .email_input_wrap {
      display: none;
      // display: flex;
      flex-flow: column;
      width: 100%;
      background: #fff4e7;
      padding: 20px;
      text-align: center;
      .title {
        font-size: 20px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #333333;
      }
      .second_title {
        font-size: 14px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #666666;
        margin-top: 8px;
      }
      .input_wrap {
        display: flex;
        justify-content: center;
        margin-top: 10px;
        input {
          width: 320px;
          height: 40px;
          border-radius: 8px;
        }
        button {
          background: #ffa200;
          height: 40px;
          margin-left: 20px;
          border-radius: 8px;
          font-size: 16px;
        }
      }
    }
  }
  /deep/.valentinesDayModal {
    top: auto !important;
    .ant-modal-content {
      padding: 0;
      background: transparent !important;
      box-shadow: none !important;
    }
    .ant-modal-body {
      padding: 0 !important;
    }
    .aboutWrap {
      position: relative;
      .close {
        position: absolute;
        right: 0;
        top: 0;
        width: 50px;
        z-index: 9;
      }
      .tc_btn {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 20%;
        margin: 0 auto;
        z-index: 8;
        cursor: pointer;
      }

      .infoBox {
        overflow: hidden;
        text-align: center;
      }
      img {
        max-width: 100%;
      }
    }
  }
}

/deep/.motherIsDayModal {
  top: auto !important;
  width: 1200px !important;
  max-width: 1200px !important;
  .ant-modal-content {
    padding: 0;
    background: transparent !important;
    box-shadow: none !important;
  }
  .ant-modal-body {
    padding: 0 !important;
  }
  .motherIsDayAboutWrap {
    position: relative;
    .close {
      position: absolute;
      right: 50px;
      top: 30px;
      width: 120px;
      height: 120px;
      z-index: 9;
    }

    .infoBox {
      overflow: hidden;
      text-align: center;
      cursor: pointer;
    }
  }
}
</style>
